var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, linearProgressClasses, styled, Typography, } from '@mui/material';
import useProgress from '../hooks/useProgress';
export var ThickLinearProgress = styled(LinearProgress)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: 10,
            borderRadius: 5
        },
        _b["&.".concat(linearProgressClasses.colorPrimary)] = {
            backgroundColor: theme.palette.primary,
        },
        _b["& .".concat(linearProgressClasses.bar)] = {
            borderRadius: 5,
            // backgroundColor: theme.palette.primary.main,
        },
        _b);
});
export function Progress(_a) {
    var className = _a.className, visiblePhases = _a.visiblePhases;
    var _b = useProgress(), phases = _b.phases, step = _b.step, phase = _b.phase;
    var progress = ((step - 1) / phases[phase].stepCount) * 100;
    var getPhaseProgress = function (index) {
        if (index < phase)
            return 100;
        if (index === phase)
            return progress;
        else
            return 0;
    };
    return (_jsx("div", __assign({ className: "flex flex-row flex-nowrap w-full max-w-md mx-auto ".concat(className) }, { children: phases
            .map(function (_phase, _index) { return (_jsxs("div", __assign({ className: "flex flex-col-reverse justify-center flex-1 gap-2 mx-2" }, { children: [_jsx(Typography, __assign({ className: "text-center uppercase" }, { children: _phase.name })), _jsx(ThickLinearProgress, { variant: "determinate", value: getPhaseProgress(_index) })] }), "phase-".concat(_phase.name))); })
            .filter(function (value, index) {
            return !visiblePhases ? true : visiblePhases === null || visiblePhases === void 0 ? void 0 : visiblePhases.includes(index);
        }) })));
}
export default Progress;
